import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { ChangeDetectorRef, Component, Input, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { catchError, Observable, switchMap, tap, EMPTY } from 'rxjs';
import { Quotation, PageResponse, PageRequest, State, PageRequestClient } from 'src/app/pages/dashboards/clients/interface/data.interface';
import { SalesQuoteService } from 'src/app/pages/dashboards/service/sales-quote.service';
import { DetailSimulationModalComponent } from 'src/app/pages/dashboards/warranties/view-deals-simulations/modals/detail-simulation-modal/detail-simulation-modal.component';
import { ModalResolutionDiscountComponent } from 'src/app/pages/dashboards/warranties/view-deals-simulations/modals/modal-resolution-discount/modal-resolution-discount.component';
import { SalesQuoteDetailModalService } from 'src/app/services/modals/sales-quote-detail-modal.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-view-simulations-client',
  templateUrl: './view-simulations-client.component.html',
  styleUrl: './view-simulations-client.component.scss'
})
export class ViewSimulationsClientComponent {
  @Input() companyId: number;
  @Input() search: string;
  @ViewChild(MatPaginator, { static: true}) paginator: MatPaginator;
  public dataSource: MatTableDataSource<Quotation> = new MatTableDataSource([]);
  public load: boolean = true;
  public loadPaginador: boolean = true;
  public cotizaciones: Quotation[];
  public responsePage: PageResponse;
  public states: State[];
  public allStates: string = "-1,-2,-3,-4,-5,-6,-7,-8,-9,-10,-11,-12"; 
  public groupsStates: { id: number; name: string; selected: boolean; states: number[] }[] = [
    { id: 1, name: "Borradores", selected: true, states: [-1,-10,-11] },
    { id: 2, name: "Listos", selected: true, states: [-4,-8,-12] },
    { id: 3, name: "$Solicitados", selected: true, states: [-3,-7] },
    { id: 4, name: "Rechazados", selected: true, states: [-5,-6,-9] }
  ];
  public pageRequest: PageRequestClient = {
    //states: "-12,-7",
    states: this.allStates,
    page: 1,
    pageSize: 5,
    search: "",
    orderDirection: "",
    orderBy: ""
  };
  public loading = true;
  public displayCols = [
    'code',
    'statusName',
    'client',
    'amount',
    'finalPrice',
    'averageRate',
    'ir',
    'executiveName',
    'createdAt',
  ];

    readonly separatorKeysCodes: number[] = [ENTER, COMMA];
    public allStatus: string[] = [];
    public defaultSelectedIds: Set<number> = new Set([-7, -12]);
    public selectedIds: Set<number> = new Set();
    public selectedIdsGrups: Set<number> = new Set([1,2,3,4]);
    public selectedIdsString: string = ''; 
    private debounceTimeout: any = null;

  constructor(private quoteService: SalesQuoteService,
     private saleQuoteDetailModalService: SalesQuoteDetailModalService,
     private cdRef: ChangeDetectorRef, private dialog: MatDialog, private cdr: ChangeDetectorRef) {
    this.pageRequest = {
      ...this.pageRequest
    };
  }
  
  ngOnInit(): void { 
    this.getCotizacionesClient(this.pageRequest);
    this.getStates();
  }

  ngAfterViewInit(): void {
    this.paginator = this.paginator;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['search']) {
      this.pageRequest = {
        ...this.pageRequest,
        search: this.search
      };
      this.getCotizacionesClient(this.pageRequest);
    }
  }

  public getCotizacionesClient(pageRequest: any) {
    this.quoteService.getCotizacionesClient(pageRequest, this.companyId).subscribe({
      next: (res)=> {
        this.responsePage = res;
        this.cotizaciones = res.data;
        this.load = false; 
        this.loadPaginador = false;
        this.setDataSource();
      },
      error: (err)=>{console.log(err)}
    })
  }

  public getStates() {
    let allState: State = {id: 0, name: 'Todos', description: 'Todos los Estados'};
    this.quoteService.getStateCotizaciones().subscribe({
      next: (res)=> {
        this.states = res;
        this.states.unshift(allState);
        this.cdRef.detectChanges()
      },
      error: (err)=>{console.log(err)}
    })
  }

  public changeSorting(sortState: Sort): void {
    if(sortState.direction === '') {
      return;
    }
    const sorting =  {
      orderBy: sortState.active,
      orderDirection: sortState.direction.toLowerCase()
    };
    this.pageRequest = {
      ...this.pageRequest,
      orderBy: sorting.orderBy,
      orderDirection: sorting.orderDirection
    };
    this.getCotizacionesClient(this.pageRequest);
  }

  public openModalDetaiSimulation(simulation: Quotation) {
    this.saleQuoteDetailModalService.openSalesQuoteDetailById(simulation.id)
    .subscribe(result => {
      this.getCotizacionesClient(this.pageRequest);
    });
  }
   
  public changePagination(event: PageEvent) {
    this.loadPaginador = true;
    const pagination = {
      page: event.pageIndex + 1,
      pageSize: event.pageSize
    };
    this.pageRequest = {
      ...this.pageRequest,
      page: pagination.page,
      pageSize: pagination.pageSize
    };
    this.getCotizacionesClient(this.pageRequest);
  }

  public onStateChange(idState: number) {
    if(idState!=0) {
      this.pageRequest = {
        ...this.pageRequest,
        states: idState.toString(),
      };
    }
    else {
      this.pageRequest = {
        ...this.pageRequest,
        states: this.allStates,
      };
    }
    this.getCotizacionesClient(this.pageRequest);
  }

  private setDataSource() {
    if (this.cotizaciones) {
      this.dataSource.data = this.cotizaciones;
      this.paginator.pageIndex = this.responsePage.page - 1;
      this.paginator.pageSize = this.responsePage.pageSize;
      this.paginator.length = this.responsePage.totalItems;
      this.loading = false;
      this.cdr.detectChanges();
    }
  }

  
  public onChipSelectionChange(groupId: number, selected: boolean): void {
    const group = this.groupsStates.find(g => g.id === groupId);
    if (!group) return;
    if (selected) {
      group.states.forEach(stateId => this.selectedIds.add(stateId));
      this.selectedIdsGrups.add(group.id);
    } else {
      group.states.forEach(stateId => this.selectedIds.delete(stateId));
      this.selectedIdsGrups.delete(group.id);
    }
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }
    this.debounceTimeout = setTimeout(() => {
      this.selectedIdsString = Array.from(this.selectedIds).join(',');
      this.pageRequest = {
        ...this.pageRequest,
        states: this.selectedIdsString
      };
      this.getCotizacionesClient(this.pageRequest);
    }, 200); 
  }

}